import { onMobileDevice, onPhone, onMobileMedium } from '../globalStyle/mediaQueries';
import { css } from '@emotion/core';


export const FLEX_COLUMN = css`
  display:        flex;
  flex-direction: column;
`;

export const FLEX_ROW = css`
  display:        flex;
  flex-direction: row;
`;

/**
 * A flex row on large screens, a flex column on tablet screens and smaller
 */
export const FLEX_ADAPTIVE = css`
  display:         flex;
  flex-direction:  row;
  
  ${onMobileDevice} {
    flex-direction: column;
  }
`;

/**
 * A flex row on large screens, a flex column on small/phone-sized screens
 */
export const FLEX_ADAPTIVE_PHONE = css`
  display:         flex;
  flex-direction:  row;
  
  ${onPhone} {
    flex-direction: column;
  }
`;


export const FLEX_ADAPTIVE_MED = css`
  display:         flex;
  flex-direction:  row;

  ${onMobileMedium} {
    flex-direction: column;
  }
`;

export const FLEX_CENTERED = css`
  align-items:     center;
  justify-content: center;
`;

export const FLEX_SPACED = css`
  align-items:     center;
  justify-content: space-around;
`;
